import { render } from "./ContactDetails.vue?vue&type=template&id=4720b914"
import script from "./ContactDetails.vue?vue&type=script&lang=js"
export * from "./ContactDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__